import React from 'react';
import {
  Box,
  Button,
  ButtonProps,
  Stack,
  StackProps,
  styled,
} from '@mui/material';
import CloseIcon from '@/public/icons/close_black.svg';
import ArrowIcon from '@/public/icons/arrow.svg';
import LinkIcon from '@/public/icons/mypage/link.svg';
import CustomToolTip from '@/components/@IntranetLibrary/ProfileCard/CustomToolTip';

export const MyMenuContentWrapper = styled(
  ({
    children,
    hasSidePadding,
    sx,
    ...props
  }: StackProps & { hasSidePadding: boolean }) => (
    <Stack
      {...props}
      sx={{
        width: '100%',
        height: '100vh',
        overflow: 'hidden auto',
        ...sx,
      }}
    >
      <Stack
        sx={{
          width: '100%',
          paddingX: hasSidePadding ? '20px' : 0,
          marginBottom: '80px',
        }}
      >
        {children}
      </Stack>
    </Stack>
  ),
)({});

export const BackButton = styled(({ children, ...props }: ButtonProps) => (
  <Button {...props}>
    <ArrowIcon />
  </Button>
))(() => ({
  display: 'inline-block',
  width: '28px',
  height: '28px',
  minWidth: 'auto',
  padding: 0,
}));

export const CloseButton = styled(({ children, ...props }: ButtonProps) => (
  <Button {...props}>
    <CloseIcon />
  </Button>
))(() => ({
  display: 'inline-block',
  width: '28px',
  height: '28px',
  minWidth: 'auto',
  padding: 0,
}));

export const LinkButton = styled(({ children, ...props }: ButtonProps) => (
  <Button {...props}>
    <LinkIcon />
  </Button>
))(() => ({
  display: 'inline-block',
  width: '28px',
  height: '28px',
  minWidth: 'auto',
  padding: 0,
}));

type MyMenuHeaderStackProps = {
  readonly onBack: () => void;
  readonly onClose: () => void;
  readonly title?: React.ReactNode;
  readonly hasBackButton: boolean;
  readonly onLinkCopy?: () => void;
} & StackProps;

export const MyMenuHeader = styled(
  ({
    onBack,
    onClose,
    children,
    title,
    hasBackButton,
    onLinkCopy,
    ...props
  }: MyMenuHeaderStackProps) => {
    return (
      <Stack
        direction={'row'}
        justifyContent={!children ? 'flex-end' : 'space-between'}
        alignItems={'center'}
        sx={{ position: 'relative' }}
        {...props}
      >
        {hasBackButton && <BackButton onClick={onBack} />}
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            fontSize: '16px',
            color: 'var(--dk-text, #000)',
            lineHeight: '24px',
            textAlign: 'center',
          }}
        >
          {title}
        </Box>
        <Box sx={{ flex: 1 }} />
        {onLinkCopy && (
          <>
            <CustomToolTip title={'프로필 카드 링크 복사'}>
              <LinkButton onClick={onLinkCopy} />
            </CustomToolTip>
            <Box sx={{ width: '12px' }} />
          </>
        )}
        <CloseButton onClick={onClose} />
      </Stack>
    );
  },
)({ width: '100%', padding: '14px 20px' });
